export default {"src":"/_next/static/media/ary.650cd336.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};